import { bus } from '@/main';
import {
    isSelfMessage
} from '@/utils/chat/messageUtils';

export default {
    data() {
        return {
            lastLiveMsgData: null,
            readStatusRefreshTimer: null
        };
    },

    methods: {
        handleMessageDeleted(data) {
            if (
                !data ||
                data.id === undefined ||
                data.id === null
            ) {
                return;
            }

            const messageIndex =
                this.messages.findIndex((message) => {
                    return (
                        String(message.id) ===
                        String(data.id)
                    );
                });

            if (messageIndex === -1) {
                return;
            }

            const deletedMessage = Object.assign(
                {},
                this.messages[messageIndex],
                data,
                {
                    delete_for_everyone: true
                }
            );

            this.$set(
                this.messages,
                messageIndex,
                deletedMessage
            );

            this.scheduleActiveRoomCacheSave();

            if (
                String(this.messageIdForReply) ===
                String(data.id)
            ) {
                this.cancelReplyMessageOnChatMethod(
                    true
                );
            }
        },

        renderLiveMessageMethod(eventOrData) {
            let data = eventOrData;

            if (
                eventOrData &&
                typeof eventOrData.data === 'string'
            ) {
                try {
                    data = JSON.parse(
                        eventOrData.data
                    );
                } catch (error) {
                    console.error(
                        'Invalid chat socket message:',
                        error
                    );
                    return;
                }
            }

            if (!data || data.type === 'pong') {
                return;
            }

            if (data.type === 'readStatus') {
                if (this.lastLiveMsgData) {
                    this.scheduleReadStatusRefresh();
                }

                return;
            }

            if (
                data.type !== 'chat_message' ||
                !data.message
            ) {
                return;
            }

            const newMessage = data.message;

            const ownMessage =
                this.isSelfMessage(newMessage);

            const shouldScroll =
                ownMessage ||
                this.isMessageListNearBottom();

            this.upsertMessage(newMessage);
            this.lastLiveMsgData = newMessage;

            if (ownMessage) {
                const sender =
                    newMessage.sender || {};

                bus.$emit('newChatMessage', {
                    chatRoomId:
                        this.selectedActvRoomId,
                    message: newMessage.message,
                    senderName: [
                        sender.first_name,
                        sender.last_name
                    ].filter(Boolean).join(' '),
                    messageId: newMessage.id
                });
            }

            if (
                this.selectedRoomInfo &&
                !this.selectedRoomInfo.pinned
            ) {
                bus.$emit(
                    'selfFullChatListOrdChangedBus',
                    this.selectedRoomInfo.chat_room
                );
            }

            if (shouldScroll) {
                this.$nextTick(
                    this.chatScrollBottomMethod
                );
            }
        },

        isSelfMessage(message) {
            return isSelfMessage(
                message,
                this.selfUserId
            );
        },

        upsertMessage(newMessage) {
            if (
                !newMessage ||
                typeof newMessage !== 'object'
            ) {
                return;
            }

            if (!Array.isArray(this.messages)) {
                this.messages = [];
            }

            const messageId = newMessage.id;

            const messageIndex =
                messageId === undefined ||
                messageId === null
                    ? -1
                    : this.messages.findIndex(
                        (message) => {
                            return (
                                String(message.id) ===
                                String(messageId)
                            );
                        }
                    );

            if (messageIndex === -1) {
                this.messages.unshift(
                    Object.assign(
                        {},
                        newMessage,
                        {
                            is_new_message: true
                        }
                    )
                );
            } else {
                this.$set(
                    this.messages,
                    messageIndex,
                    Object.assign(
                        {},
                        this.messages[messageIndex],
                        newMessage
                    )
                );
            }

            this.scheduleActiveRoomCacheSave();
        },

        scheduleReadStatusRefresh() {
            this.clearReadStatusRefresh();

            this.readStatusRefreshTimer =
                setTimeout(() => {
                    this.readStatusRefreshTimer =
                        null;

                    this.allMessageListMethod();
                }, 250);
        },

        clearReadStatusRefresh() {
            if (this.readStatusRefreshTimer) {
                clearTimeout(
                    this.readStatusRefreshTimer
                );

                this.readStatusRefreshTimer = null;
            }
        }
    }
};
